import { useState } from 'react';
import { draftInScope, downloadDraft } from './mfsDraft.model';
import FeatureAction from '@/shared/feature-availability/FeatureAction';
import MfsDraftWizard from './MfsDraftWizard';
import styles from './MfsDraftWorkspace.module.css';

export default function MfsDraftWorkspace({ companyId, siteId, assetId, drafts, onSave, editor, onEditorChange, onPreview }) {
  const [showAll, setShowAll] = useState(false);
  const [message, setMessage] = useState('');
  const visible = showAll ? drafts : drafts.filter(draft => draftInScope(draft, siteId, assetId));

  function save(snapshot) {
    onSave(snapshot);
    onEditorChange(null);
    setMessage('Local draft saved. Export its JSON before leaving this page. Use Show all local drafts if it is outside the current scope.');
  }

  return <div className={styles.container}>
    <header className={styles.header}>
      <div><h2>Maintenance schedule drafts</h2><p>Use real inspection objects to prepare scope and technique assignments.</p></div>
      {/* <button type="button" className={styles.primary} onClick={() => onEditorChange({ initial: null })}>Draft maintenance schedule</button> */}
      <FeatureAction feature="inspection" action="draft" className={styles.primary}
        reason="Creating local drafts is not available in this release."
        onClick={() => onEditorChange({ initial: null })}>
        Draft maintenance schedule
      </FeatureAction>
    </header>
    <p className={styles.notice}>These drafts exist only while this Inspection Suite page remains open. Switching its tabs or scope keeps them; leaving the page, refreshing or switching company clears them. Export JSON to retain a copy. Backend schedules are not connected.</p>
    {message && <p role="status" className={styles.notice}>{message}</p>}
    <label className={styles.toggle}><input type="checkbox" checked={showAll} onChange={event => setShowAll(event.target.checked)} />Show all local drafts, across location scopes</label>
    <div className={styles.grid}>
      {visible.map(snapshot => <article className={styles.card} key={snapshot.id}>
        <header><span>LOCAL DRAFT</span><h3>{snapshot.details.name}</h3></header>
        <div className={styles.body}>
          <p>{snapshot.details.owner}</p>
          <p>First due {snapshot.details.due} · Every {snapshot.details.frequency} months</p>
          <p><strong>{snapshot.components.length} components</strong> across {new Set(snapshot.components.map(row => row.siteId)).size} sites</p>
          <small>Counts describe the full draft scope, including locations outside the current view.</small>
          <div className={styles.actions}>
            {/* <button type="button" className={styles.button} onClick={() => onEditorChange({ initial: snapshot })}>Edit draft</button> */}
            <FeatureAction feature="inspection" action="draft" className={styles.button}
              onClick={() => onEditorChange({ initial: snapshot })}>Edit draft</FeatureAction>
            <button type="button" className={styles.button} onClick={() => onPreview({ draftId: snapshot.id })}>Preview items</button>
            {/* <button type="button" className={styles.button} onClick={() => downloadDraft(snapshot)}>Export JSON</button> */}
            <FeatureAction feature="inspection" action="export" className={styles.button}
              onClick={() => downloadDraft(snapshot)}>Export JSON</FeatureAction>
          </div>
        </div>
      </article>)}
    </div>
    {!visible.length && <p className={styles.empty}>{drafts.length ? 'No local drafts include components in this scope.' : 'No local drafts yet. Start by defining the work and selecting registered components.'}</p>}
    {editor && <MfsDraftWizard companyId={companyId} siteId={siteId} assetId={assetId}
      initial={editor.initial} otherDrafts={drafts} onSave={save} onClose={() => onEditorChange(null)} />}
  </div>;
}